'use client';

import { DashboardData } from '@/types/api';
import ExpiredDevicesChart from './expired-devices-chart';

const MoreIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
    <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
  </svg>
);

interface ChartsSectionProps {
  data: DashboardData;
}

export default function ChartsSection({ data }: ChartsSectionProps) {
  return (
    <div className="bg-white dark:bg-gray-900 rounded-2xl p-5 shadow-sm border border-gray-200 dark:border-gray-800 h-full flex flex-col justify-between">
      <div className="flex items-center justify-between pb-3 border-b border-gray-100 dark:border-gray-800">
        <div>
          <h3 className="font-semibold text-gray-900 dark:text-white tracking-tight">
            Expired Devices By Month
          </h3>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
            Tren perangkat yang masa aktifnya kedaluwarsa per bulan
          </p>
        </div>
        <button className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors duration-200">
          <MoreIcon />
        </button>
      </div>

      <div className="mt-2 flex-1 flex items-center justify-center">
        {/* @ts-expect-error -- custom control */}
        <ExpiredDevicesChart data={data?.expired_devices_by_date} />
      </div>
    </div>
  );
}
